function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusConfidentialUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M24 2.782c-5.5 0-10 4.5-10 10v7.655l4-.244v-7.411c0-3.301 2.7-6 6-6s6 2.699 6 6v.172l4 .007v-.18c0-5.5-4.5-10-10-10Z",
    transform: "matrix(1.05158 0 0 1.01148 -1.238 -.276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffd800",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.94116247
    },
    d: "M34.63 45.218H13.37c-1.947 0-3.543-1.8-3.543-4v-18c0-2.199 1.596-4 3.544-4h21.258c1.948 0 3.544 1.801 3.544 4v18c0 2.2-1.596 4-3.544 4z",
    transform: "matrix(1.05158 0 0 1.01148 -1.238 -.276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c79700",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M27 32.218a3 3 0 1 1-6.002-.001 3 3 0 0 1 6.002.001z",
    transform: "matrix(1.05158 0 0 1.01148 -1.238 -.276)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusConfidentialUnlocked);
export default __webpack_public_path__ + "static/media/status-confidential-unlocked.768f90772ad10647a70cfcbc6c698962.svg";
export { ForwardRef as ReactComponent };